<template>
  <div class="info">
    <h1>{{title}}</h1>
    <md-divider/>
    <div class="body">
      <slot/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info {
  margin: 2em;
}
.body {
  margin-top: 1em;
}
</style>

<script>
export default {
  name: "Info",
  props: { title: String }
};
</script>


// WEBPACK FOOTER //
// Info.vue?4e8fc1e3